import { FC } from 'react'

import {
  Cluster,
  Icon,
  Label,
  Select,
  Stack,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { INCOTERM_CODES, INCOTERMS_DESCRIPTIONS, IncoTermsCode, isValidIncoTermsCode } from '../../domain/inco'

type IncoTermSelectorProps = {
  value: IncoTermsCode | undefined
  setValue: (newValue: IncoTermsCode) => void
  errors?: unknown
  required?: boolean
  disabled?: boolean
}

export const IncotermSelector: FC<IncoTermSelectorProps> = ({ value, setValue, errors, disabled, required }) => {
  const { translate } = useLocalisation()

  return (
    <Stack gap={2}>
      <Cluster gap={4}>
        <Label>{translate('details.details.general.edit.fields.incoTerms.label')}</Label>
        {disabled ? (
          <Tooltip>
            <TooltipTrigger>
              <Icon name="HelpCircle" size="sm" />
            </TooltipTrigger>
            <TooltipContent>{translate('details.details.general.edit.fields.incoTerms.tooltip')}</TooltipContent>
          </Tooltip>
        ) : null}
      </Cluster>
      <Select
        placeholder={translate('details.details.general.edit.fields.incoTerms.placeholder')}
        value={value}
        onChange={(newIncoTerms) => {
          if (isValidIncoTermsCode(newIncoTerms)) {
            setValue(newIncoTerms)
          }
        }}
        state={errors ? 'negative' : undefined}
        items={INCOTERM_CODES.map((code) => ({
          value: code,
          label: `${INCOTERMS_DESCRIPTIONS[code].abbreviation} – ${INCOTERMS_DESCRIPTIONS[code].description}`,
        }))}
        required={required}
        disabled={disabled}
      />
    </Stack>
  )
}
